exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.share-button_share-button_36Wbh {\r\n    background: var(--data-primary);\r\n}\r\n\r\n.share-button_share-button-is-shared_2QzeZ {\r\n    background: var(--ui-black-transparent);\r\n    cursor: default;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"share-button": "share-button_share-button_36Wbh",
	"shareButton": "share-button_share-button_36Wbh",
	"share-button-is-shared": "share-button_share-button-is-shared_2QzeZ",
	"shareButtonIsShared": "share-button_share-button-is-shared_2QzeZ"
};